/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_organization_business_address_no_states_found = /** @type {(inputs: {}) => string} */ () => {
	return `No se encontraron estados`
};

const en_organization_business_address_no_states_found = /** @type {(inputs: {}) => string} */ () => {
	return `No states found`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const organization_business_address_no_states_found = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.organization_business_address_no_states_found(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("organization_business_address_no_states_found", locale)
	if (locale === "es") return es_organization_business_address_no_states_found(inputs)
	return en_organization_business_address_no_states_found(inputs)
};
export { organization_business_address_no_states_found as "organization.business_address.no_states_found" }